import { getActionType } from './util';

const initialState = {
  formdata: undefined,
  k12Schools: undefined,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case getActionType('populateFormData'):
      return {
        ...state,
        formdata: action.formdata,
      };

    case getActionType('populateK12Schools'):
      return {
        ...state,
        k12Schools: action.k12Schools,
      };

    default:
      return state;
  }
};
